import { Component, Inject, OnChanges, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnChanges {
  isSearch: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: { isSearch: boolean }) {
  }
  ngOnChanges() {

  }
  ngOnInit(): void {
    console.log(this.isSearch, this.data.isSearch)
    this.isSearch = this.data.isSearch
  }

}
